import { createSlice } from '@reduxjs/toolkit';
import { saveToLocalStorage, loadFromLocalStorage } from '../../utilis/localstorage';

// Initialize state from localStorage or use default empty state
const initialState = {
  orders: loadFromLocalStorage('cartOrders') || [],
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { orderId, tableNo, items, notes } = action.payload;
      const existingOrder = state.orders.find(
        (order) => order.orderId === orderId && order.tableNo === tableNo
      );

      if (existingOrder) {
        // Merge items with existing order
        items.forEach((newItem) => {
          const existingItem = existingOrder.items.find(
            (item) =>
              item.id === newItem.id &&
              JSON.stringify(item.attributes) === JSON.stringify(newItem.attributes)
          );
          if (existingItem) {
            // Update quantity if item with same attributes exists
            existingItem.quantity += newItem.quantity;
          } else {
            // Add new item to existing order
            existingOrder.items.push(newItem);
          }
        });
        // Update notes if provided
        if (notes) {
          existingOrder.notes = notes;
        }
      } else {
        // Add new order
        state.orders.push({ orderId, tableNo, items, notes });
      }
      // Save updated cart to localStorage
      saveToLocalStorage('cartOrders', state.orders);
    },
    removeFromCart: (state, action) => {
      const { orderId, tableNo, itemId, attributes } = action.payload;
      const order = state.orders.find(
        (order) => order.orderId === orderId && order.tableNo === tableNo
      );
      if (order) {
        order.items = order.items.filter(
          (item) =>
            item.id !== itemId ||
            JSON.stringify(item.attributes) !== JSON.stringify(attributes)
        );
        // Remove order if no items remain
        if (order.items.length === 0) {
          state.orders = state.orders.filter(
            (o) => o.orderId !== orderId || o.tableNo !== tableNo
          );
        }
      }
      // Save updated cart to localStorage
      saveToLocalStorage('cartOrders', state.orders);
    },
    updateQuantity: (state, action) => {
      const { orderId, tableNo, itemId, quantity, attributes } = action.payload;
      const order = state.orders.find(
        (order) => order.orderId === orderId && order.tableNo === tableNo
      );
      if (order) {
        const item = order.items.find(
          (item) =>
            item.id === itemId &&
            JSON.stringify(item.attributes) === JSON.stringify(attributes)
        );
        if (item) {
          item.quantity = quantity;
        }
      }
      // Save updated cart to localStorage
      saveToLocalStorage('cartOrders', state.orders);
    },
    clearCart: (state) => {
      state.orders = [];
      // Save updated cart to localStorage
      saveToLocalStorage('cartOrders', state.orders);
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;